export const encodeEmail = (key: string, email: string) => {
  const encodedEmail = btoa(email);
  return `${key}-${encodedEmail}`;
};
